import React, { useRef } from "react";
import "../../../App.css";
import { useReactToPrint } from "react-to-print";
import { Button } from "react-bootstrap";

const Receipt = ({
  setPayPopup,
  regValcash,
  regValcard,
  regValcredit,
  total,
  change,
  orderValidate,
  setShowBill,
  itemsInCart,
  currentOrderRef,
  currentCustomer,
  setItemsInCart,
}) => {
  const componentRef = useRef();

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: "Receipt",
  });
  console.log(itemsInCart);
  return (
    <div className="    receipt-popup row ">
      <div className="receipt-btns col-12 p-4">
        <Button
          variant="danger"
          onClick={() => {
            localStorage.removeItem("actualOrderId");
            setItemsInCart([]);
            setPayPopup(false);
            setShowBill(false);
          }}
        >
          Close
        </Button>
        <Button className=" bx" onClick={handlePrint}>
          Print Receipt
        </Button>
      </div>
      <div className="pos-receipt receipt-container col-12">
        <div className="receipt-content" ref={componentRef}>
          <img
            alt="Logo"
            className="pos-receipt-logo"
            src="/web/image?model=res.company&amp;id=1&amp;field=logo"
          />
          <br />
          <div className="d-flex flex-column align-items-center receipt-header">
            <div className="pos-receipt-contact">
              <div>{currentCustomer.email}</div>
              <div className="cashier">
                <div>--------------------------------</div>
                <div>Served by {currentCustomer.name}</div>
              </div>
              <div>
                <span className="fs-2">
                  {localStorage.getItem("actualOrderId")}
                </span>
              </div>
            </div>
          </div>
          <br />
          <br />
          <div className="order-container bg-view overflow-y-auto flex-grow-1 d-flex flex-column text-start receipt-items">
            {itemsInCart.map((item) => (
              <li
                key={item.id}
                className="orderline p-2 lh-sm cursor-pointer pe-none px-0"
              >
                <div className="d-flex justify-content-between">
                  <div className="product-name d-inline-block flex-grow-1 fw-bolder pe-1 text-truncate">
                    <span className="text-wrap">{item.ProductName}</span>
                  </div>
                  <div className="product-price d-inline-block text-end price fw-bolder">
                    ₹&nbsp;{item.SalesPrice}
                  </div>
                </div>
                <ul className="info-list ms-2">
                  <li className="price-per-unit">
                    <em className="qty fst-normal fw-bolder me-1">
                      {item.Quantity}
                    </em>
                    Units x ₹&nbsp;{item.quantity} <span>/ Units</span>
                  </li>
                </ul>
              </li>
            ))}
          </div>
          <div className="pos-receipt-right-align">--------</div>
          <br />
          <div className="pos-receipt-amount">
            TOTAL{" "}
            <span className="pos-receipt-right-align">₹&nbsp;{total}</span>
          </div>
          <div className="paymentlines" style={{ paddingLeft: "7.5em" }}>
            Cash<span className="pos-receipt-right-align">{regValcash}</span>
            Card<span className="pos-receipt-right-align">{regValcard}</span>
            Credit
            <span className="pos-receipt-right-align">{regValcredit}</span>
          </div>
          <div className="pos-receipt-taxes">
            <span></span>
            <span>Tax</span>
            <span>Amount</span>
            <span>Base</span>
            <span>Total</span>
            <span>SGST</span>
            <span>2.5%</span>
            <span>25.00</span>
            <span>1,000.00</span>
            <span>1,025.00</span>
            <span>CGST</span>
            <span>2.5%</span>
            <span>25.00</span>
            <span>1,000.00</span>
            <span>1,025.00</span>
            <span></span>
            <span></span>
            <span>50.00</span>
            <span>1,000.00</span>
            <span>1,050.00</span>
          </div>
          <div className="before-footer"></div>
          <br />
          <table style={{ width: "100%" }}>
            <thead>
              <tr>
                <th className="text-center fw-bolder" colSpan="6">
                  --- HSN Summary ---
                </th>
              </tr>
              <tr>
                <th className="text-center">HSN Code</th>
                <th className="text-center">Rate%</th>
                <th className="text-center">CGST</th>
                <th className="text-center">SGST</th>
                <th className="text-center">IGST</th>
                <th className="text-center">CESS</th>
              </tr>
            </thead>
          </table>
          <div className="after-footer"></div>
          <br />
          <br />
          <div className="pos-receipt-order-data receipt-footer">
            <p>Powered by Defcon Innovations</p>
            <div>Order {currentOrderRef}</div>
            <div id="order-date">{new Date().toLocaleString()}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Receipt;
